export const name = 'paymentsWixCodeSdk' as const
export const namespace = 'pay' as const
